import script from "./seguridadAccesosForm.vue?vue&type=script&setup=true&lang=js"
export * from "./seguridadAccesosForm.vue?vue&type=script&setup=true&lang=js"

import "./seguridadAccesosForm.vue?vue&type=style&index=0&id=85adf5fc&scoped=true&lang=css"
import "./seguridadAccesosForm.vue?vue&type=style&index=1&id=85adf5fc&lang=css"
import "./seguridadAccesosForm.vue?vue&type=style&index=2&id=85adf5fc&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-85adf5fc"]])

export default __exports__